import axios from "axios";
import apiUrl from "../config/apiUrl";
// react 中使用antd  此处自定义
// vue中使用element-ui 此处自定义
// import { Loading} from "element-ui";
 
// 创建axios默认请求
axios.defaults.baseURL = apiUrl.serverUrl;
// axios.defaults.baseURL = "https://acl.c-pan.cn/";
// 配置超时时间
axios.defaults.timeout = 100000;
// 配置请求拦截
axios.interceptors.request.use(

    config => {
        let token = localStorage.getItem('token')
        if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }

);
// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    // console.log("response:",response);
    
    
    return response;
  },
  function(error) {
    // 对响应错误做点什么
    console.log(" error.response.status:",error.response.status);
    if(error.response.status==401){
      alert("登录过期，请重新登录")
      window.location.href="/#/login"
    }
    return Promise.reject(error);
  }
);
/**
 * get请求
 * @method get
 * @param {url, params, loading} 请求地址，请求参数，是否需要加载层
 */
var get = function(url, params, loading) {
  return new Promise((resolve, reject) => {
    // {
    //   params: params
    // }
    axios
      .get(url, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};
/**
 * post请求
 * @method post
 * @param {url, params} 请求地址，请求参数，是否需要加载层
 */
var post = function(url, data) {
  return new Promise((resolve, reject) => {
    // qs.stringify(data)
    axios
      .post(url, data)
      .then(res => {
        console.log(res);
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};
// export default { get, post };
export default axios;